var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlide5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 376,
    viewBox: "0 0 717 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717 0H0V375.23H717V0Z",
    fill: "#B4E8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M656.354 375.229C659.939 363.757 661.911 351.568 661.911 338.901C661.911 283.692 624.926 237.087 574.317 222.568C577.902 213.904 579.874 204.404 579.874 194.426C579.874 153.676 546.832 120.634 506.083 120.634C499.092 120.634 492.281 121.59 485.887 123.443C458.582 79.5264 409.945 50.3086 354.437 50.3086C282.678 50.3086 222.33 99.1841 204.883 165.447C121.711 168.016 55.0898 236.251 55.0898 320.02C55.0898 339.499 58.6748 358.081 65.2473 375.229H656.354Z",
    fill: "#5BC5DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M525.441 333.525H191.558C185.404 333.525 180.385 328.506 180.385 322.352C180.385 316.198 185.404 311.179 191.558 311.179H525.381C531.536 311.179 536.555 316.198 536.555 322.352C536.614 328.566 531.595 333.525 525.441 333.525Z",
    fill: "#1698B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0268 59.2119C48.5168 59.2119 30.3528 73.6714 24.7363 93.3889H115.317C109.701 73.6714 91.5368 59.2119 70.0268 59.2119Z",
    fill: "#F1F9FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.65 59.2119C172.14 59.2119 153.976 73.6714 148.359 93.3889H239C233.324 73.6714 215.16 59.2119 193.65 59.2119Z",
    fill: "#F1F9FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.736 44.6328C103.964 44.6328 78.0329 65.2466 70.0264 93.4486H199.505C191.438 65.2466 165.507 44.6328 134.736 44.6328Z",
    fill: "#F1F9FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2571 88.4902C63.9329 88.4902 52.7596 97.393 49.2344 109.582H105.22C101.814 97.4527 90.5814 88.4902 77.2571 88.4902Z",
    fill: "#FEE6E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.617 88.4902C140.293 88.4902 129.12 97.393 125.595 109.582H181.64C178.175 97.4527 166.942 88.4902 153.617 88.4902Z",
    fill: "#FEE6E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.23 79.4678C98.2291 79.4678 82.2161 92.1945 77.2568 109.642H157.202C152.303 92.1945 136.23 79.4678 117.23 79.4678Z",
    fill: "#FEE6E2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M542.231 166.105C524.545 166.105 509.608 177.996 504.947 194.188H579.456C574.915 177.996 559.977 166.105 542.231 166.105Z",
    fill: "#F1F9FC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M643.926 166.105C626.24 166.105 611.302 177.996 606.642 194.188H681.15C676.549 177.996 661.612 166.105 643.926 166.105Z",
    fill: "#F1F9FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M595.469 154.096C570.194 154.096 548.864 171.065 542.231 194.248H648.706C642.074 171.005 620.743 154.096 595.469 154.096Z",
    fill: "#F1F9FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M510.623 61.3037C497.299 61.3037 486.126 70.2065 482.601 82.3955H538.586C535.121 70.2065 523.888 61.3037 510.623 61.3037Z",
    fill: "#FEF6F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M586.984 61.3037C573.659 61.3037 562.486 70.2065 558.961 82.3955H614.947C611.481 70.2065 600.308 61.3037 586.984 61.3037Z",
    fill: "#FEF6F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M550.596 52.2812C531.595 52.2812 515.582 65.008 510.623 82.455H590.569C585.609 65.008 569.596 52.2812 550.596 52.2812Z",
    fill: "#FEF6F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M583.936 78.6328C573.958 78.6328 565.474 85.3248 562.904 94.5263H605.028C602.399 85.3846 593.974 78.6328 583.936 78.6328Z",
    fill: "#DBF0F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M641.416 78.6328C631.438 78.6328 622.953 85.3248 620.384 94.5263H662.508C659.819 85.3846 651.394 78.6328 641.416 78.6328Z",
    fill: "#DBF0F7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M614.05 71.8809C599.77 71.8809 587.701 81.4409 583.996 94.5859H644.105C640.34 81.4409 628.331 71.8809 614.05 71.8809Z",
    fill: "#DBF0F7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M410.132 126H262V304.104H410.132V126Z",
    fill: "#B4E8F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 142.013H274.646V145.133H312.008V142.013Z",
    fill: "#39AECB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 142.013H316.77V145.133H354.131V142.013Z",
    fill: "#39AECB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 142.013H358.894V145.133H396.255V142.013Z",
    fill: "#39AECB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 148.419H274.646V151.539H312.008V148.419Z",
    fill: "#39AECB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 148.419H316.77V151.539H354.131V148.419Z",
    fill: "#39AECB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 148.419H358.894V151.539H396.255V148.419Z",
    fill: "#39AECB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 154.74H274.646V157.861H312.008V154.74Z",
    fill: "#39AECB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 154.74H316.77V157.861H354.131V154.74Z",
    fill: "#39AECB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 154.74H358.894V157.861H396.255V154.74Z",
    fill: "#39AECB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 161.063H274.646V164.184H312.008V161.063Z",
    fill: "#39AECB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 161.063H316.77V164.184H354.131V161.063Z",
    fill: "#39AECB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 161.063H358.894V164.184H396.255V161.063Z",
    fill: "#39AECB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 167.387H274.646V170.507H312.008V167.387Z",
    fill: "#39AECB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 167.387H316.77V170.507H354.131V167.387Z",
    fill: "#39AECB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 167.387H358.894V170.507H396.255V167.387Z",
    fill: "#39AECB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 173.79H274.646V176.91H312.008V173.79Z",
    fill: "#39AECB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 173.79H316.77V176.91H354.131V173.79Z",
    fill: "#39AECB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 173.79H358.894V176.91H396.255V173.79Z",
    fill: "#39AECB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 180.113H274.646V183.234H312.008V180.113Z",
    fill: "#39AECB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 180.113H316.77V183.234H354.131V180.113Z",
    fill: "#39AECB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 180.113H358.894V183.234H396.255V180.113Z",
    fill: "#39AECB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 186.437H274.646V189.557H312.008V186.437Z",
    fill: "#39AECB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 186.437H316.77V189.557H354.131V186.437Z",
    fill: "#39AECB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 186.437H358.894V189.557H396.255V186.437Z",
    fill: "#39AECB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 192.76H274.646V195.88H312.008V192.76Z",
    fill: "#39AECB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 192.76H316.77V195.88H354.131V192.76Z",
    fill: "#39AECB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 192.76H358.894V195.88H396.255V192.76Z",
    fill: "#39AECB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 199.163H274.646V202.283H312.008V199.163Z",
    fill: "#39AECB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 199.163H316.77V202.283H354.131V199.163Z",
    fill: "#39AECB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 199.163H358.894V202.283H396.255V199.163Z",
    fill: "#39AECB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 205.487H274.646V208.608H312.008V205.487Z",
    fill: "#39AECB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 205.487H316.77V208.608H354.131V205.487Z",
    fill: "#39AECB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 205.487H358.894V208.608H396.255V205.487Z",
    fill: "#39AECB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 211.81H274.646V214.93H312.008V211.81Z",
    fill: "#39AECB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 211.81H316.77V214.93H354.131V211.81Z",
    fill: "#39AECB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 211.81H358.894V214.93H396.255V211.81Z",
    fill: "#39AECB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 218.132H274.646V221.252H312.008V218.132Z",
    fill: "#39AECB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 218.132H316.77V221.252H354.131V218.132Z",
    fill: "#39AECB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 218.132H358.894V221.252H396.255V218.132Z",
    fill: "#39AECB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 224.537H274.646V227.657H312.008V224.537Z",
    fill: "#39AECB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 224.537H316.77V227.657H354.131V224.537Z",
    fill: "#39AECB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 224.537H358.894V227.657H396.255V224.537Z",
    fill: "#39AECB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 230.858H274.646V233.979H312.008V230.858Z",
    fill: "#39AECB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 230.858H316.77V233.979H354.131V230.858Z",
    fill: "#39AECB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 230.858H358.894V233.979H396.255V230.858Z",
    fill: "#39AECB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 237.182H274.646V240.302H312.008V237.182Z",
    fill: "#39AECB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 237.182H316.77V240.302H354.131V237.182Z",
    fill: "#39AECB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 237.182H358.894V240.302H396.255V237.182Z",
    fill: "#39AECB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 243.505H274.646V246.625H312.008V243.505Z",
    fill: "#39AECB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 243.505H316.77V246.625H354.131V243.505Z",
    fill: "#39AECB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 243.505H358.894V246.625H396.255V243.505Z",
    fill: "#39AECB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 249.91H274.646V253.03H312.008V249.91Z",
    fill: "#39AECB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 249.91H316.77V253.03H354.131V249.91Z",
    fill: "#39AECB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 249.91H358.894V253.03H396.255V249.91Z",
    fill: "#39AECB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 256.232H274.646V259.353H312.008V256.232Z",
    fill: "#39AECB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 256.232H316.77V259.353H354.131V256.232Z",
    fill: "#39AECB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 256.232H358.894V259.353H396.255V256.232Z",
    fill: "#39AECB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 262.555H274.646V265.675H312.008V262.555Z",
    fill: "#39AECB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 262.555H316.77V265.675H354.131V262.555Z",
    fill: "#39AECB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 262.555H358.894V265.675H396.255V262.555Z",
    fill: "#39AECB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 268.879H274.646V271.999H312.008V268.879Z",
    fill: "#39AECB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 268.879H316.77V271.999H354.131V268.879Z",
    fill: "#39AECB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 268.879H358.894V271.999H396.255V268.879Z",
    fill: "#39AECB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M312.008 275.283H274.646V278.403H312.008V275.283Z",
    fill: "#39AECB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 275.283H316.77V278.403H354.131V275.283Z",
    fill: "#39AECB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 275.283H358.894V278.403H396.255V275.283Z",
    fill: "#39AECB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 142.013H316.77V170.013H354.131V142.013Z",
    fill: "#39AECB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M354.131 205.732H316.77V233.733H354.131V205.732Z",
    fill: "#39AECB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9312 265.753C107.322 284.813 137.376 285.949 137.376 285.949L59.9997 216.938C59.9997 216.997 64.6005 246.693 85.9312 265.753Z",
    fill: "#1698B8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 216.997L137.376 286.008C137.376 286.008 132.835 256.253 111.444 237.193C90.054 218.132 59.9997 216.997 59.9997 216.997Z",
    fill: "#39AECB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M113.118 237.552C118.555 265.634 141.738 284.814 141.738 284.814L122.14 183C122.14 183.06 107.681 209.469 113.118 237.552Z",
    fill: "#1698B8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M122.14 183.06L141.738 284.874C141.738 284.874 156.138 258.464 150.76 230.322C145.323 202.18 122.14 183.06 122.14 183.06Z",
    fill: "#39AECB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M229.63 285.889C251.14 285.889 269.304 300.348 274.921 320.066H184.28C189.956 300.348 208.12 285.889 229.63 285.889Z",
    fill: "#0383A4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M106.007 285.889C127.517 285.889 145.681 300.348 151.298 320.066H60.6571C66.3334 300.348 84.4376 285.889 106.007 285.889Z",
    fill: "#0383A4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M164.922 271.25C195.693 271.25 221.624 291.864 229.631 320.066H100.153C108.219 291.924 134.15 271.25 164.922 271.25Z",
    fill: "#0383A4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M314.132 140.75H166V318.854H314.132V140.75Z",
    fill: "#F1F9FC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 156.681H178.646V159.801H216.007V156.681Z",
    fill: "#39AECB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 156.681H220.77V159.801H258.131V156.681Z",
    fill: "#39AECB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 156.681H262.976V159.801H300.337V156.681Z",
    fill: "#39AECB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 163.085H178.646V166.205H216.007V163.085Z",
    fill: "#39AECB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 163.085H220.77V166.205H258.131V163.085Z",
    fill: "#39AECB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 163.085H262.976V166.205H300.337V163.085Z",
    fill: "#39AECB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 169.408H178.646V172.528H216.007V169.408Z",
    fill: "#39AECB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 169.408H220.77V172.528H258.131V169.408Z",
    fill: "#39AECB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 169.408H262.976V172.528H300.337V169.408Z",
    fill: "#39AECB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 175.731H178.646V178.852H216.007V175.731Z",
    fill: "#39AECB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 175.731H220.77V178.852H258.131V175.731Z",
    fill: "#39AECB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 175.731H262.976V178.852H300.337V175.731Z",
    fill: "#39AECB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 182.055H178.646V185.175H216.007V182.055Z",
    fill: "#39AECB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 182.055H220.77V185.175H258.131V182.055Z",
    fill: "#39AECB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 182.055H262.976V185.175H300.337V182.055Z",
    fill: "#39AECB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 188.458H178.646V191.578H216.007V188.458Z",
    fill: "#39AECB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 188.458H220.77V191.578H258.131V188.458Z",
    fill: "#39AECB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 188.458H262.976V191.578H300.337V188.458Z",
    fill: "#39AECB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 194.782H178.646V197.903H216.007V194.782Z",
    fill: "#39AECB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 194.782H220.77V197.903H258.131V194.782Z",
    fill: "#39AECB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 194.782H262.976V197.903H300.337V194.782Z",
    fill: "#39AECB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 201.104H178.646V204.225H216.007V201.104Z",
    fill: "#39AECB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 201.104H220.77V204.225H258.131V201.104Z",
    fill: "#39AECB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 201.104H262.976V204.225H300.337V201.104Z",
    fill: "#39AECB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 207.426H178.646V210.546H216.007V207.426Z",
    fill: "#39AECB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 207.426H220.77V210.546H258.131V207.426Z",
    fill: "#39AECB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 207.426H262.976V210.546H300.337V207.426Z",
    fill: "#39AECB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 213.832H178.646V216.952H216.007V213.832Z",
    fill: "#39AECB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 213.832H220.77V216.952H258.131V213.832Z",
    fill: "#39AECB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 213.832H262.976V216.952H300.337V213.832Z",
    fill: "#39AECB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 220.153H178.646V223.274H216.007V220.153Z",
    fill: "#39AECB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 220.153H220.77V223.274H258.131V220.153Z",
    fill: "#39AECB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 220.153H262.976V223.274H300.337V220.153Z",
    fill: "#39AECB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 226.477H178.646V229.597H216.007V226.477Z",
    fill: "#39AECB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 226.477H220.77V229.597H258.131V226.477Z",
    fill: "#39AECB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 226.477H262.976V229.597H300.337V226.477Z",
    fill: "#39AECB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 232.8H178.646V235.92H216.007V232.8Z",
    fill: "#39AECB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 232.8H220.77V235.92H258.131V232.8Z",
    fill: "#39AECB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 232.8H262.976V235.92H300.337V232.8Z",
    fill: "#39AECB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 239.205H178.646V242.325H216.007V239.205Z",
    fill: "#39AECB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 239.205H220.77V242.325H258.131V239.205Z",
    fill: "#39AECB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 239.205H262.976V242.325H300.337V239.205Z",
    fill: "#39AECB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 245.527H178.646V248.648H216.007V245.527Z",
    fill: "#39AECB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 245.527H220.77V248.648H258.131V245.527Z",
    fill: "#39AECB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 245.527H262.976V248.648H300.337V245.527Z",
    fill: "#39AECB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 251.85H178.646V254.97H216.007V251.85Z",
    fill: "#39AECB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 251.85H220.77V254.97H258.131V251.85Z",
    fill: "#39AECB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 251.85H262.976V254.97H300.337V251.85Z",
    fill: "#39AECB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 258.173H178.646V261.293H216.007V258.173Z",
    fill: "#39AECB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 258.173H220.77V261.293H258.131V258.173Z",
    fill: "#39AECB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 258.173H262.976V261.293H300.337V258.173Z",
    fill: "#39AECB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 264.578H178.646V267.698H216.007V264.578Z",
    fill: "#39AECB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 264.578H220.77V267.698H258.131V264.578Z",
    fill: "#39AECB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 264.578H262.976V267.698H300.337V264.578Z",
    fill: "#39AECB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 270.9H178.646V274.021H216.007V270.9Z",
    fill: "#39AECB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 270.9H220.77V274.021H258.131V270.9Z",
    fill: "#39AECB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 270.9H262.976V274.021H300.337V270.9Z",
    fill: "#39AECB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 277.222H178.646V280.342H216.007V277.222Z",
    fill: "#39AECB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 277.222H220.77V280.342H258.131V277.222Z",
    fill: "#39AECB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 277.222H262.976V280.342H300.337V277.222Z",
    fill: "#39AECB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 283.546H178.646V286.666H216.007V283.546Z",
    fill: "#39AECB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 283.546H220.77V286.666H258.131V283.546Z",
    fill: "#39AECB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 283.546H262.976V286.666H300.337V283.546Z",
    fill: "#39AECB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M216.007 289.95H178.646V293.07H216.007V289.95Z",
    fill: "#39AECB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 289.95H220.77V293.07H258.131V289.95Z",
    fill: "#39AECB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M300.337 289.95H262.976V293.07H300.337V289.95Z",
    fill: "#39AECB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 156.681H178.646V178.851H258.131V156.681Z",
    fill: "#39AECB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M299.927 252.343H262.565V280.343H299.927V252.343Z",
    fill: "#39AECB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M528.132 135.783H380V313.887H528.132V135.783Z",
    fill: "#DBF0F7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 151.796H392.646V154.916H430.007V151.796Z",
    fill: "#39AECB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 151.796H434.77V154.916H472.131V151.796Z",
    fill: "#39AECB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 151.796H476.976V154.916H514.337V151.796Z",
    fill: "#39AECB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 158.118H392.646V161.238H430.007V158.118Z",
    fill: "#39AECB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 158.118H434.77V161.238H472.131V158.118Z",
    fill: "#39AECB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 158.118H476.976V161.238H514.337V158.118Z",
    fill: "#39AECB"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 164.524H392.646V167.645H430.007V164.524Z",
    fill: "#39AECB"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 164.524H434.77V167.645H472.131V164.524Z",
    fill: "#39AECB"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 164.524H476.976V167.645H514.337V164.524Z",
    fill: "#39AECB"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 170.847H392.646V173.967H430.007V170.847Z",
    fill: "#39AECB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 170.847H434.77V173.967H472.131V170.847Z",
    fill: "#39AECB"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 170.847H476.976V173.967H514.337V170.847Z",
    fill: "#39AECB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 177.169H392.646V180.289H430.007V177.169Z",
    fill: "#39AECB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 177.169H434.77V180.289H472.131V177.169Z",
    fill: "#39AECB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 177.169H476.976V180.289H514.337V177.169Z",
    fill: "#39AECB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 183.492H392.646V186.612H430.007V183.492Z",
    fill: "#39AECB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 183.492H434.77V186.612H472.131V183.492Z",
    fill: "#39AECB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 183.492H476.976V186.612H514.337V183.492Z",
    fill: "#39AECB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 189.897H392.646V193.018H430.007V189.897Z",
    fill: "#39AECB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 189.897H434.77V193.018H472.131V189.897Z",
    fill: "#39AECB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 189.897H476.976V193.018H514.337V189.897Z",
    fill: "#39AECB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 196.22H392.646V199.34H430.007V196.22Z",
    fill: "#39AECB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 196.22H434.77V199.34H472.131V196.22Z",
    fill: "#39AECB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 196.22H476.976V199.34H514.337V196.22Z",
    fill: "#39AECB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 202.543H392.646V205.663H430.007V202.543Z",
    fill: "#39AECB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 202.543H434.77V205.663H472.131V202.543Z",
    fill: "#39AECB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 202.543H476.976V205.663H514.337V202.543Z",
    fill: "#39AECB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 208.865H392.646V211.986H430.007V208.865Z",
    fill: "#39AECB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 208.865H434.77V211.986H472.131V208.865Z",
    fill: "#39AECB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 208.865H476.976V211.986H514.337V208.865Z",
    fill: "#39AECB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 215.271H392.646V218.392H430.007V215.271Z",
    fill: "#39AECB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 215.271H434.77V218.392H472.131V215.271Z",
    fill: "#39AECB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 215.271H476.976V218.392H514.337V215.271Z",
    fill: "#39AECB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 221.593H392.646V224.713H430.007V221.593Z",
    fill: "#39AECB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 221.593H434.77V224.713H472.131V221.593Z",
    fill: "#39AECB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 221.593H476.976V224.713H514.337V221.593Z",
    fill: "#39AECB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 227.914H392.646V231.034H430.007V227.914Z",
    fill: "#39AECB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 227.914H434.77V231.034H472.131V227.914Z",
    fill: "#39AECB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 227.914H476.976V231.034H514.337V227.914Z",
    fill: "#39AECB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 234.238H392.646V237.359H430.007V234.238Z",
    fill: "#39AECB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 234.238H434.77V237.359H472.131V234.238Z",
    fill: "#39AECB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 234.238H476.976V237.359H514.337V234.238Z",
    fill: "#39AECB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 240.642H392.646V243.762H430.007V240.642Z",
    fill: "#39AECB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 240.642H434.77V243.762H472.131V240.642Z",
    fill: "#39AECB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 240.642H476.976V243.762H514.337V240.642Z",
    fill: "#39AECB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 246.967H392.646V250.087H430.007V246.967Z",
    fill: "#39AECB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 246.967H434.77V250.087H472.131V246.967Z",
    fill: "#39AECB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 246.967H476.976V250.087H514.337V246.967Z",
    fill: "#39AECB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 253.289H392.646V256.409H430.007V253.289Z",
    fill: "#39AECB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 253.289H434.77V256.409H472.131V253.289Z",
    fill: "#39AECB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 253.289H476.976V256.409H514.337V253.289Z",
    fill: "#39AECB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 259.611H392.646V262.732H430.007V259.611Z",
    fill: "#39AECB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 259.611H434.77V262.732H472.131V259.611Z",
    fill: "#39AECB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 259.611H476.976V262.732H514.337V259.611Z",
    fill: "#39AECB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 266.016H392.646V269.136H430.007V266.016Z",
    fill: "#39AECB"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 266.016H434.77V269.136H472.131V266.016Z",
    fill: "#39AECB"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 266.016H476.976V269.136H514.337V266.016Z",
    fill: "#39AECB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 272.34H392.646V275.46H430.007V272.34Z",
    fill: "#39AECB"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 272.34H434.77V275.46H472.131V272.34Z",
    fill: "#39AECB"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 272.34H476.976V275.46H514.337V272.34Z",
    fill: "#39AECB"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 278.662H392.646V281.782H430.007V278.662Z",
    fill: "#39AECB"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 278.662H434.77V281.782H472.131V278.662Z",
    fill: "#39AECB"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 278.662H476.976V281.782H514.337V278.662Z",
    fill: "#39AECB"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 284.983H392.646V288.104H430.007V284.983Z",
    fill: "#39AECB"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M472.131 284.983H434.77V288.104H472.131V284.983Z",
    fill: "#39AECB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 284.983H476.976V288.104H514.337V284.983Z",
    fill: "#39AECB"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M430.007 151.796H392.646V224.712H430.007V151.796Z",
    fill: "#39AECB"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 151.796H476.976V179.797H514.337V151.796Z",
    fill: "#39AECB"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M514.337 234.483H476.976V262.484H514.337V234.483Z",
    fill: "#39AECB"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M619.474 285.752C598.083 304.812 568.029 305.948 568.029 305.948L645.405 236.996C645.405 236.996 640.864 266.692 619.474 285.752Z",
    fill: "#1698B8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M645.405 236.996L568.029 306.007C568.029 306.007 572.57 276.252 593.961 257.192C615.351 238.131 645.405 236.996 645.405 236.996Z",
    fill: "#39AECB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M592.347 257.552C586.91 285.634 563.727 304.814 563.727 304.814L583.325 203C583.325 203.06 597.725 229.469 592.347 257.552Z",
    fill: "#1698B8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M583.325 203.06L563.727 304.874C563.727 304.874 549.327 278.464 554.705 250.322C560.082 222.18 583.325 203.06 583.325 203.06Z",
    fill: "#39AECB"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M582.548 295.374C600.593 295.374 615.769 307.444 620.489 323.994H544.547C549.267 307.444 564.504 295.374 582.548 295.374Z",
    fill: "#FEBBC4"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M479.001 295.374C497.046 295.374 512.222 307.444 516.942 323.994H441C445.72 307.444 460.957 295.374 479.001 295.374Z",
    fill: "#FEBBC4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M528.295 283.065C554.047 283.065 575.796 300.333 582.488 323.934H474.042C480.854 300.393 502.543 283.065 528.295 283.065Z",
    fill: "#FEBBC4"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M192.591 320.339L190.415 318.775C190.687 318.435 215.376 281.367 217.212 255.522L221.769 255.727C219.865 282.252 193.748 318.775 192.591 320.339Z",
    fill: "#C68642"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M237.344 325.236C237.208 324.76 221.905 280.483 220.816 255.658L225.373 255.522C226.393 280.007 239.792 324.012 239.928 324.42L237.344 325.236Z",
    fill: "#C68642"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M191.367 316.666C191.367 316.666 188.579 318.503 189.055 319.115C189.531 319.727 197.556 327.753 197.964 327.413C199.393 326.256 193.816 318.707 192.999 318.231C192.183 317.755 191.775 316.394 191.367 316.666Z",
    fill: "#00365D"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M249.11 197.304C249.11 197.304 251.423 191.182 253.055 190.706C254.619 190.23 253.055 196.283 249.927 198.732L249.11 197.304Z",
    fill: "#C68642"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M248.565 196.76C249.586 197.1 250.538 197.44 251.49 197.916C244.893 213.423 240.54 219.476 223.265 220.428C220.612 220.564 220.408 219.544 220.748 217.504C220.34 217.368 220.272 217.368 220.748 217.504C221.088 215.463 221.904 215.327 224.217 215.191C239.316 214.579 241.56 209.41 248.565 196.76Z",
    fill: "#EC577F"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M215.375 288.238C216.191 288.782 216.94 289.394 217.688 289.938C219.456 291.231 221.429 292.251 223.401 293.203C224.557 293.747 225.781 294.291 227.006 294.631C228.91 295.107 230.882 295.107 232.855 294.835C230.27 277.288 231.562 261.237 225.917 244.574C225.373 244.778 224.829 244.982 224.217 245.186C224.217 244.574 224.285 243.893 224.285 243.281C220.68 243.689 217.008 244.097 213.403 244.574C214.355 261.169 211.771 273.683 206.806 285.857C209.798 285.721 212.859 286.538 215.375 288.238Z",
    fill: "#00365D"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M227.346 195.264C226.122 195.128 224.558 196.012 224.15 197.236C223.674 198.46 224.626 199.753 225.782 200.161C226.938 200.569 229.319 199.345 229.795 198.12C230.271 196.964 228.911 195.4 227.346 195.264Z",
    fill: "#302004"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M223.265 193.562C221.021 191.726 217.076 191.386 214.628 193.154C212.179 194.923 212.315 198.595 214.016 200.908C215.716 203.22 220.817 204.649 224.694 202.268C227.142 200.704 226.122 195.875 223.265 193.562Z",
    fill: "#302004"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M224.626 201.588C222.994 200.227 220.069 199.887 218.369 201.111C216.6 202.404 216.737 205.056 218.029 206.825C219.321 208.593 223.742 209.273 225.51 207.981C227.279 206.757 226.734 203.356 224.626 201.588Z",
    fill: "#302004"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M221.973 203.901C223.605 207.37 227.346 209.07 229.454 208.05C231.563 207.03 231.291 203.765 229.658 200.296C228.026 196.828 225.509 195.875 223.333 196.828C221.225 197.848 220.34 200.432 221.973 203.901Z",
    fill: "#C68642"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M220.953 205.805C221.361 206.621 222.653 207.302 223.197 207.03C223.809 206.757 223.605 206.009 223.265 205.193C222.857 204.377 222.041 203.833 221.497 204.105C220.885 204.377 220.613 204.989 220.953 205.805Z",
    fill: "#C68642"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M220.477 201.929C220.477 201.929 220.137 199.344 221.565 197.712C222.925 196.079 226.326 194.651 228.502 197.372C228.502 197.372 229.863 199.48 227.21 200.908C224.558 202.337 224.49 200.704 223.673 202.609C222.857 204.513 221.225 203.969 221.089 204.377L220.477 201.929Z",
    fill: "#302004"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M227.822 251.918C224.761 251.986 222.449 250.966 219.864 249.401C217.892 248.177 215.308 247.701 213.267 246.817C211.771 237.363 213.879 222.06 217.552 216.075C220.817 210.77 220.817 211.654 221.973 211.178C223.605 210.498 225.51 210.702 226.802 211.926L226.87 211.994C228.366 213.422 228.434 216.551 228.638 219.816C228.842 223.08 230.134 222.468 227.21 228.113C225.918 230.494 227.89 247.021 227.822 251.918Z",
    fill: "#F87895"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M223.197 204.376L227.21 204.716C227.142 205.26 226.598 210.497 226.053 212.402C225.781 212.946 224.761 213.082 223.741 212.606C222.857 212.197 222.245 211.449 222.313 210.905C222.653 209.817 223.061 206.348 223.197 204.376Z",
    fill: "#C68642"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M236.596 323.265C236.596 323.265 235.78 326.529 236.596 326.597C237.412 326.665 248.702 327.005 248.77 326.529C248.975 324.761 239.725 323.061 238.841 323.265C237.888 323.469 236.664 322.789 236.596 323.265Z",
    fill: "#00365D"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M214.219 250.354C214.219 250.354 218.912 255.386 218.64 257.087C218.368 258.787 213.403 254.502 212.519 250.422L214.219 250.354Z",
    fill: "#C68642"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M215.512 251.441C214.628 252.121 213.88 252.665 212.86 253.413C201.842 234.778 204.562 228.929 218.913 214.102C221.089 211.857 225.102 215.53 221.089 218.931C206.875 230.969 207.895 234.098 215.512 251.441Z",
    fill: "#EC577F"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M477.338 310.272C477.406 310.204 477.474 310.136 477.542 310.068C477.95 309.388 477.746 308.503 477.066 308.095L468.292 302.586C467.612 302.178 466.728 302.382 466.32 303.062C465.912 303.743 466.116 304.627 466.796 305.035L475.57 310.544C476.114 310.884 476.862 310.748 477.338 310.272Z",
    fill: "#FFD1BA"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M477.201 307.62C477.201 307.62 480.533 309.524 479.989 310.272C479.445 311.02 470.875 320.61 470.399 320.202C468.767 318.978 474.616 310.068 475.5 309.456C476.316 308.844 476.724 307.348 477.201 307.62Z",
    fill: "#00365D"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M419.594 195.602C419.594 195.602 423.947 189.549 425.851 189.481C427.755 189.413 424.219 195.602 420.07 197.371L419.594 195.602Z",
    fill: "#FFD1BA"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M419.05 195.262C420.343 195.806 421.635 196.35 422.927 196.962C412.385 218.386 424.151 226.14 430.817 201.655C431.837 197.914 433.673 198.866 435.646 200.839C435.986 200.159 435.986 200.159 435.646 200.839C437.618 202.743 437.89 202.131 436.19 206.144C424.696 232.465 404.564 221.243 419.05 195.262Z",
    fill: "#00365D"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M433.265 325.304C433.333 325.304 433.469 325.304 433.537 325.304C434.285 325.168 434.829 324.352 434.693 323.604L432.653 313.402C432.517 312.654 431.701 312.109 430.953 312.246C430.204 312.382 429.66 313.198 429.796 313.946L431.837 324.148C431.973 324.896 432.585 325.304 433.265 325.304Z",
    fill: "#FFD1BA"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M430.068 319.387C431.632 319.319 433.128 319.183 434.693 318.979C430.136 294.494 426.667 261.643 438.91 238.791C435.169 236.955 431.428 235.186 427.687 233.418C418.71 253.346 426.327 298.371 430.068 319.387Z",
    fill: "#00496F"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M471.012 309.252C472.032 308.028 472.985 306.736 473.937 305.443C446.051 286.74 436.461 269.056 442.243 234.846C438.094 234.098 433.877 233.554 429.66 232.941C430.68 272.797 440.202 285.856 471.012 309.252Z",
    fill: "#00496F"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M435.034 323.399C435.034 323.399 435.918 327.14 435.034 327.208C434.149 327.344 421.295 327.684 421.227 327.072C420.955 325.032 431.497 323.127 432.517 323.331C433.537 323.603 434.897 322.855 435.034 323.399Z",
    fill: "#00365D"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M424.287 241.783C426.736 240.967 431.769 242.259 434.149 241.783C437.754 241.035 439.454 241.307 442.991 241.511C443.467 230.425 443.059 218.862 443.875 207.98C444.079 205.668 444.147 204.307 443.739 202.607C443.195 200.295 441.971 198.73 440.406 197.846C438.502 196.826 436.053 196.894 433.605 198.118C433.265 198.254 432.857 198.458 432.517 198.798C431.088 199.887 429.728 202.131 429.524 206.212C429.048 216.55 426.259 231.105 424.287 241.783Z",
    fill: "#00365D"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M432.585 198.867L432.789 205.804L433.061 214.51L436.666 206.416L440.474 197.915C438.57 196.894 436.122 196.962 433.673 198.187C433.333 198.323 432.925 198.595 432.585 198.867Z",
    fill: "#84DAED"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M439.929 191.181C437.549 194.854 433.06 196.146 430.816 194.718C428.571 193.29 429.455 189.617 431.836 185.944C434.216 182.272 437.277 181.592 439.453 183.088C441.698 184.448 442.31 187.509 439.929 191.181Z",
    fill: "#FFD1BA"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M440.747 193.493C440.203 194.377 438.638 194.853 438.026 194.513C437.414 194.105 437.686 193.289 438.23 192.473C438.774 191.589 439.794 191.181 440.407 191.521C441.087 191.929 441.359 192.677 440.747 193.493Z",
    fill: "#FFD1BA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M439.386 190.569L434.829 190.093C434.761 190.705 434.285 196.69 434.489 198.934C434.625 199.615 435.781 199.955 437.005 199.615C438.094 199.343 438.91 198.662 438.978 198.05C438.91 196.758 439.182 192.745 439.386 190.569Z",
    fill: "#FFD1BA"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M437.686 192.473C437.006 191.725 436.394 192.405 434.761 193.289C433.129 194.174 430.273 193.97 430.069 190.161C429.933 187.712 428.572 191.725 428.572 191.725C428.3 193.697 428.844 194.922 430.137 195.738C431.973 196.962 434.897 196.758 437.482 195.194C437.958 194.242 438.162 192.949 437.686 192.473Z",
    fill: "#6A420E"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M441.971 189.209C441.971 189.209 442.719 186.352 441.427 184.312C440.134 182.271 436.53 180.095 433.605 182.883C433.605 182.883 431.769 184.992 434.489 187.032C437.278 189.073 437.618 187.168 438.23 189.481C438.842 191.725 440.814 191.385 440.882 191.861L441.971 189.209Z",
    fill: "#6A420E"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M432.789 205.804L433.061 214.51L436.666 206.416L436.53 201.111H434.965L432.789 205.804Z",
    fill: "#C0285C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M462.51 242.531C462.51 242.531 461.898 250.353 463.326 251.645C464.755 253.005 466.183 245.66 464.075 241.375L462.51 242.531Z",
    fill: "#FFD1BA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M461.694 243.551C462.85 243.279 464.007 242.939 465.163 242.599C459.45 223.283 457.885 217.434 444.419 202.335C442.378 200.023 441.698 200.295 439.93 202.335C439.454 202.199 439.454 202.131 439.93 202.335C438.162 204.307 438.57 204.852 440.746 207.096C455.369 221.991 453.669 224.915 461.694 243.551Z",
    fill: "#00365D"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M340.762 91.0509C336.58 91.9472 333.054 94.3969 330.724 97.6234C328.394 94.3969 324.869 92.0069 320.686 91.0509C313.695 89.4974 306.764 92.5447 303 98.2209C307.541 95.7712 313.456 94.8749 319.551 96.1894C323.136 96.9662 326.422 98.4599 329.051 100.372C329.649 100.79 330.186 101.208 330.664 101.686C331.202 101.208 331.74 100.79 332.278 100.372C334.966 98.4599 338.193 96.9662 341.778 96.1894C347.872 94.8749 353.788 95.7114 358.329 98.2209C354.684 92.5447 347.753 89.4974 340.762 91.0509Z",
    fill: "#FED6D6"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M391.967 84.1199C387.785 83.1639 383.602 83.8212 380.077 85.7332C379.36 81.7897 377.209 78.1449 373.803 75.5159C368.127 71.1542 360.539 70.9152 354.743 74.4404C359.882 74.1417 365.618 75.8744 370.577 79.6984C373.505 81.9689 375.775 84.6577 377.388 87.5257C377.747 88.1232 378.046 88.7804 378.344 89.3779C379.002 89.1987 379.719 89.0194 380.376 88.8999C383.602 88.3024 387.187 88.3622 390.772 89.1987C396.867 90.5729 401.826 93.9189 404.873 98.1014C403.917 91.4094 398.958 85.7332 391.967 84.1199Z",
    fill: "#FED6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide5);
export default __webpack_public_path__ + "static/media/slide5.0e0e2b8039300efdd253bfee30408f17.svg";
export { ForwardRef as ReactComponent };